import { useCallback, useContext, useEffect, useState } from "react";
import { faEdit } from "@fortawesome/free-solid-svg-icons"

import { Table } from 'antd'

import { ApplicationContext } from 'context'

import ButtonPrimary from "components/ButtonPrimary"
import SearchBar from "components/SearchBar"

import { discectError } from "lib/utils"
import api from 'lib/api'

import styles from "./styles.module.scss"

const FindPower = ({ onSelect }) => {
  const { contextAgency, contextError, contextLoading } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [error, setError] = contextError // eslint-disable-line
  const [agency] = contextAgency // eslint-disable-line

  const [powers, setPowers] = useState(null)
  const [search, setSearch] = useState(null)

  const agencyId = agency.id

  const _fetchPowers = useCallback(async () => {
    setIsLoading(true)
    try {
      const { powers: incomingPowers } = await api.powers.fetchPowers(agencyId, {})
      setPowers(() => incomingPowers)
    } catch(e) {
      console.error(e)
      setError(discectError(e))
    }
    setIsLoading(false)
  }, [agencyId, setError, setIsLoading])

  useEffect(() => {
    if (!powers) _fetchPowers() 
  }, [_fetchPowers, agencyId, powers, setError, setIsLoading])

  const _getFilteredPowers = () => {
    if (powers) {
      return powers
        .filter(power => {
          let ok = true
          if (ok && search) {
            ok = (power.po_number.indexOf(search) >= 0)
          }
          return ok
        })
      }
    return []
  }

  const _getTable = () => {
    if (powers) {   
      const columns = [
        {
          title: 'Power Number',
          dataIndex: 'powerNumber',
          key: 'powerNumber',
          align: 'left',
          render: (_, { po_number }) => {
            return (
              <div className={styles.agencyInfo}>
                <p>{po_number}</p>
              </div>
            )
          }
        },
        {
          title: 'Power Value',
          dataIndex: 'powerAmount',
          key: 'powerAmount',
          width: 120,
          align: 'center',
          render: (_, { bond_value }) => {
            return (
              <div className={styles.agencyInfo}>
                <p>{bond_value}</p>
              </div>
            )
          }
        },
        {
          title: 'Status',
          key: 'status',
          dataIndex: 'status',
          width: 120,
          align: 'center',
          filters: [
            {
              text: 'Open',
              value: 'OPEN'
            },
            {
              text: 'Executed',
              value: 'EXECUTED'
            },
            {
              text: 'Void',
              value: 'VOID'
            }
          ],
          onFilter: (value, record) => (record.bondStatus === value),
          render: (_, { status }) => {
            return (
              <div className={styles.agencyInfo}>
                <p>{status}</p>
              </div>
            )
          }
        },
        {
          key: 'action',
          width: 120,
          render: (_, record) => {
            return (
              <div className={styles.actions}>
                <ButtonPrimary small color="navy" onClick={() => onSelect(record)} icon={faEdit}>Select</ButtonPrimary>
              </div>
            )
          }
        }
      ]

      return (
        <Table
          bordered
          dataSource={_getFilteredPowers()}
          columns={columns}
          size="small"
        />
      )
    }
    return null
  }

  return (
    <div className={styles.findPower}>
      <div className={styles.findPower__filters}>
        <div className={styles.findPower__filters__left}>
          <SearchBar placeholder="Enter the Power Number" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div className={styles.findPower__filters__right}>
          
        </div>
      </div>
      <div>
        {_getTable()}
      </div>
    </div>
  )
}

export default FindPower